module.exports = __webpack_public_path__ + "static/img/1.2034373.png";


//////////////////
// WEBPACK FOOTER
// ./static/templates/egyszarnyu-ajto/layers/1.png
// module id = 805
// module chunks = 0